module.exports = __webpack_public_path__ + "img/脉诊仪.3e72ccaa.jpg";